import { useLang } from "../../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-technical bg-ink py-4" data-testid="marquee">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="px-8 font-display text-sm font-bold uppercase tracking-[0.22em] text-[#f8f7f4]/85">
              {item}
            </span>
            <span className="font-mono-tech text-red-brand text-xs">+</span>
          </span>
        ))}
      </div>
    </div>
  );
};
